<template>
    <div>
        <v-dialog
            v-model="display"
            width="1000"
            scrollable
            persistent>
            <v-card flat>
                <v-card-title>
                    {{ $t('customer_statement') }}
                    <v-spacer></v-spacer>
                    <v-menu
                        ref="dateFromMenu"
                        v-model="dateFromMenu"
                        :close-on-content-click="false"
                        :return-value.sync="form.from"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.from"
                            :rules="rules.from"
                            :label="$t('date_from')"
                            prepend-icon="mdi-calendar"
                            hide-details
                            solo
                            flat
                            dense
                            :width="20"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.from" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateFromMenu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dateFromMenu.save(form.from)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                    <v-menu
                        ref="dateToMenu"
                        v-model="dateToMenu"
                        :close-on-content-click="false"
                        :return-value.sync="form.to"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.to"
                            :rules="rules.to"
                            :label="$t('date_from')"
                            prepend-icon="mdi-calendar"
                            hide-details
                            style="width='120'"
                            solo
                            flat
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.to" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateToMenu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dateToMenu.save(form.to)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                     <v-btn icon>
                         <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>
                                    {{ $t('code') }}
                                </th>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {{ $t('customer') }}
                                </th>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {{ $t('phone') }}
                                </th>
                                <td>

                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-simple-table  dense>
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th width="100px">Date</th>
                                <th width="140px">Transaction</th>
                                <th width="120px">Transaction No</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="6">{{ statement.opening_balance.description }}</td>
                                <td>{{ statement.opening_balance.balance }}</td>
                            </tr>
                            <tr v-for="trans in statement.transactions" :key="trans.transaction_id">
                                <td width="130">{{ trans.date }}</td>
                                <td>{{ trans.transaction }}</td>
                                <td>{{ trans.transaction_code }}</td>
                                <td>{{ trans.description }}</td>
                                <td>{{ formatPrice(trans.debit) }}</td>
                                <td>{{ formatPrice(trans.credit) }}</td>
                                <td>{{ formatPrice(trans.balance) }}</td>
                            </tr>
                            <tr>
                                <td colspan="4">{{ statement.ending_balance.description }}</td>
                                <td>{{ formatPrice(statement.ending_balance.debit) }}</td>
                                <td>{{ formatPrice(statement.ending_balance.credit) }}</td>
                                <td>{{ formatPrice(statement.ending_balance.balance) }}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="error"
                        @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        >
                        {{ $t("print")}}
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapActions, mapState } from 'vuex';
import formatPrice from '@/utils/formatPrice'
export default {
    name: "CustomerStatementDisplayDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            dateToMenu: false,
            dateFromMenu: false,
            loading: {
                data: true
            },
            form: {
                from: new Date().toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10),
                customer_id: null,
            },
            rules: {
                from: [
                    v => !!v || this.$t("rules_required")
                ],
                to : [
                    v => !!v || this.$t("rules_required")
                ]
            }
        }
    },
    computed: {
        ...mapState("sales/customer", ["statement"])
    },
    methods: {
        ...mapActions("sales/customer", ["fetchCustomerStatement"]),
        formatPrice,
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                this.form.customer_id = this.openParams.customer_id;
                await this.fetchCustomerStatement(this.form);
                this.loading.data = false;

            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.createdDataFetch();
                else this.close()
            }
        },
        close() {
            this.display = false;
            
        }
       
    }
}
</script>